export default "__VITE_PUBLIC_ASSET__6a9c6dcd__"